import React, { useEffect, useState } from 'react';
import { Box, Container } from '@material-ui/core';
import TextField from '@mui/material/TextField';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { useSnackbar } from 'notistack';

import Page from '../../components/Layout/Page';
import Results from './Results';
import { getCategoryCountTree } from '../../requests/api/categorycounts';
import useStyles from './styles';

function ProductCounts() {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const [supermarkets, setSupermarkets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [date, setDate] = useState(new Date());

  useEffect(() => {
    let active = true;

    const fetchTree = async () => {
      setLoading(true);
      const response = await getCategoryCountTree(date.valueOf());

      if (!active) return;

      if (response.success) {
        setSupermarkets(response.data?.data?.supermarkets || []);
      } else {
        enqueueSnackbar('Error al cargar el conteo de categorías.', { variant: 'error' });
      }
      setLoading(false);
    };

    fetchTree();

    return () => {
      active = false;
    };
  }, [date, enqueueSnackbar]);

  return (
    <Page
      className={classes.root}
      title="FH Engel | Conteo de productos"
    >
      <Container maxWidth={false}>
        <Box mb={2} display="flex" justifyContent="flex-end">
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DesktopDatePicker
              label="Fecha"
              inputFormat="dd/MM/yyyy"
              value={date}
              onChange={(newDate) => setDate(newDate)}
              renderInput={(params) => <TextField {...params} />}
            />
          </LocalizationProvider>
        </Box>
        <Results supermarkets={supermarkets} loading={loading} />
      </Container>
    </Page>
  );
}

export default ProductCounts;
